export { default } from './ViewTab';
